<h1 mat-dialog-title>{{ getDialogTitle() | translate }}</h1>

<div mat-dialog-content>
  <form [formGroup]="userForm">
    <mat-form-field appearance="outline" style="margin-top: 0.5rem" [style.width.px]="350">
      <mat-label>{{ 'Full Name' | translate }}</mat-label>
      <input matInput formControlName="fullName" placeholder="{{ 'Enter full name' | translate }}" />
      <mat-error *ngIf="userForm.get('fullName')?.invalid && userForm.get('fullName')?.touched">
        {{ 'Full Name is required' | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" [style.width.px]="350">
      <mat-label>{{ 'Email' | translate }}</mat-label>
      <input matInput formControlName="email" placeholder="{{ 'Enter email' | translate }}" />
      <mat-error *ngIf="userForm.get('email')?.invalid && userForm.get('email')?.touched">
        {{ 'Please enter a valid email address' | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" [style.width.px]="350">
      <mat-label>{{ 'Role' | translate }}</mat-label>
      <mat-select formControlName="role">
        <mat-option value="ADMIN">{{ 'Admin' | translate }}</mat-option>
        <mat-option value="USER">{{ 'User' | translate }}</mat-option>
        <mat-option value="COACH">{{ 'Coach' | translate }}</mat-option>
      </mat-select>
      <mat-error *ngIf="userForm.get('role')?.invalid && userForm.get('role')?.touched">
        {{ 'Role is required' | translate }}
      </mat-error>
    </mat-form-field>

    <mat-form-field appearance="outline" [style.width.px]="350">
      <mat-label>{{ getUpdatePassword() | translate }}</mat-label>
      <input matInput formControlName="password" type="password" placeholder="{{ getEnterPassword() | translate }}" />
      <mat-error *ngIf="userForm.get('password')?.invalid && userForm.get('password')?.touched">
        {{ 'Password is required when creating a new user' | translate }}
      </mat-error>
    </mat-form-field>
  </form>
</div>

<div mat-dialog-actions>
  <button mat-button (click)="onCancel()">{{ 'Cancel' | translate }}</button>
  <button mat-button [disabled]="userForm.invalid" color="primary" (click)="onSave()">
    {{ getCreateOrUpdate() | translate }}
  </button>
</div>
